<template>
  <icon-base
    v-if="expanded"
    height="21"
    width="21"
    icon="shrink-white"
    iconColor="none"
    :iconName="iconName"
    :class="{ border: hasBorder }"
  />
  <icon-base
    v-else
    height="21"
    width="21"
    icon="expand-white"
    iconColor="none"
    :iconName="iconName"
    :class="{ border: hasBorder }"
  />
</template>
<script type="text/javascript">
export default {
  name: "expand-button",
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    iconName: {
      type: String,
      default: "",
    },
  },
};
</script>
